import "Main/vue";

import InitComponent from "Modules/InitComponent";
import { safeSetItem } from "Utils/safeLocalStorage";
import CommentsList from "./components/CommentsList.vue";
import CreateCommentModal from "./components/CreateComment/CreateCommentModal.vue";
import CreatorAdminBar from "./components/CreatorAdminBar.vue";
import CreatorModal from "./components/CreatorModal.vue";
import CurrentEvents from "./components/CurrentEvents/index.vue";
import DeceasedImage from "./components/DeceasedImage.vue";
import FuneralProgramPages from "./components/FuneralProgramPages.vue";
import GlobalSingleCommentModal from "./components/GlobalSingleCommentModal.vue";
import HeroNameDate from "./components/HeroNameDate.vue";
// Creator stuff
import HeroText from "./components/HeroText.vue";
import LiveInfo from "./components/LiveAndRsvp/LiveInfo.vue";
import RsvpContact from "./components/LiveAndRsvp/RsvpContact.vue";
import RsvpDescription from "./components/LiveAndRsvp/RsvpDescription.vue";
import RsvpForm from "./components/LiveAndRsvp/RsvpForm.vue";
import MemorialFund from "./components/MemorialFund.vue";
import MemoryBookPanel from "./components/MemoryBook/MemoryBookPanel.vue";
import MemoryBookSection from "./components/MemoryBook/MemoryBookSection.vue";
import MobileNavigation from "./components/MobileNavigation/index.vue";
import Navigation from "./components/Navigation.vue";
import ObituaryHeroImage from "./components/ObituaryHeroImage.vue";
import ObituaryImageInfo from "./components/ObituaryImageInfo.vue";
import PlantedTreesInfo from "./components/PlantedTreesInfo.vue";
import SingleCommentLandingPageModal from "./components/SingleCommentLandingPageModal.vue";
import SlideshowSection from "./components/Slideshow/SlideshowSection.vue";
import SlideshowViewer from "./components/Slideshow/SlideshowViewer.vue";
import { openViewer } from "./composables/useSlideshow";

// Store
import store from "./stores/store";

// The hero buttons name their modal context in a Vue-style attribute: toggleModal('…').
const TOGGLE_MODAL_CONTEXT = /toggleModal\('([^']+)'\)/;

const creatorAdminBar = document.getElementById(
  "obituary-creator-admin-bar__vue"
);
const initCreatorAdminBar = new InitComponent({
  components: { CreatorAdminBar },
  selectors: creatorAdminBar,
  store,
  template: "<CreatorAdminBar />",
});

initCreatorAdminBar.init();

const heroNameDate = document.getElementById(
  "obituary-single__hero-name-date__vue"
);
const initHeroNameDate = new InitComponent({
  components: { HeroNameDate },
  selectors: heroNameDate,
  store,
  template: "<HeroNameDate />",
});

initHeroNameDate.init();

const memorialFund = document.getElementById(
  "obituary-single__hero-memorial-fund__vue"
);
const initMemorialFund = new InitComponent({
  components: { MemorialFund },
  selectors: memorialFund,
  store,
  template: "<MemorialFund />",
});

initMemorialFund.init();

const memorialFundMobile = document.getElementById(
  "obituary-single__hero-mobile-fund-container__vue"
);
const initMemorialFundMobile = new InitComponent({
  components: { MemorialFund },
  selectors: memorialFundMobile,
  store,
  template: "<MemorialFund />",
});

initMemorialFundMobile.init();

const obituaryHeroImage = document.getElementById(
  "obituary-single__hero-background__vue"
);
const initObituaryHeroImage = new InitComponent({
  components: { ObituaryHeroImage },
  selectors: obituaryHeroImage,
  store,
  template: "<ObituaryHeroImage />",
});

initObituaryHeroImage.init();

const deceasedImage = document.getElementById(
  "obituary-single__hero-deceased-image__vue"
);

// Capture the original image before Vue replaces the content
if (deceasedImage) {
  const img = deceasedImage.querySelector("img");
  if (img) {
    // Store the image details in the Vuex store
    store.commit("creator/setState", {
      deceasedImage: {
        alt: img.alt,
        src: img.src,
        srcset: img.srcset || "",
      },
    });
  }
}

const initDeceasedImage = new InitComponent({
  components: { DeceasedImage },
  selectors: deceasedImage,
  store,
  template: "<DeceasedImage />",
});

initDeceasedImage.init();

const heroText = document.getElementById("obituary-single__hero-text__vue");
const initHeroText = new InitComponent({
  components: { HeroText },
  selectors: heroText,
  store,
  template: "<HeroText />",
});

initHeroText.init();

const creator = document.getElementById("obituary-creator__vue");
const initCreator = new InitComponent({
  components: { CreatorModal },
  selectors: creator,
  store,
  template: "<CreatorModal />",
});

initCreator.init();

const plantedTreesInfo = document.getElementById("obituary-planted-trees__vue");
const initPlantedTreesInfo = new InitComponent({
  components: { PlantedTreesInfo },
  selectors: plantedTreesInfo,
  store,
  template: "<PlantedTreesInfo />",
});

initPlantedTreesInfo.init();

// Live
const liveInfo = document.getElementById("obituary-live__vue");
const initLiveInfo = new InitComponent({
  components: { LiveInfo },
  selectors: liveInfo,
  store,
  template: "<LiveInfo />",
});

initLiveInfo.init();

// Rsvp description
const rsvpDescription = document.getElementById(
  "obituary-rsvp-description__vue"
);
const initRsvpDescription = new InitComponent({
  components: { RsvpDescription },
  selectors: rsvpDescription,
  store,
  template: "<RsvpDescription />",
});

initRsvpDescription.init();

// Rsvp form
const rsvpForm = document.getElementById("obituary-rsvp-form__vue");
const initRsvpForm = new InitComponent({
  components: { RsvpForm },
  selectors: rsvpForm,
  store,
  template: "<RsvpForm />",
});

initRsvpForm.init();

// Funeral advisor
const rsvpContact = document.getElementById("obituary-rsvp-contact__vue");
const initRsvpContact = new InitComponent({
  components: { RsvpContact },
  selectors: rsvpContact,
  store,
  template: "<RsvpContact />",
});

initRsvpContact.init();

// Current events
const currentEvents = document.getElementById("obituary-current-events__vue");
const initCurrentEvent = new InitComponent({
  components: { CurrentEvents },
  // The block is the whole section, gone when no card qualifies.
  replaceHost: true,
  selectors: currentEvents,
  store,
  template: "<CurrentEvents />",
});

initCurrentEvent.init();

// The memory book's panel, outside the highlights block so it outlives it
const memoryBook = document.getElementById("obituary-memory-book__vue");
const initMemoryBook = new InitComponent({
  components: { MemoryBookPanel },
  data: { orderId: memoryBook?.dataset.orderId ?? "" },
  selectors: memoryBook,
  template: '<MemoryBookPanel :order-id="orderId" />',
});

initMemoryBook.init();

// Image info
const imageInfo = document.getElementById("obituary-obituary-image-info__vue");
const initImageInfo = new InitComponent({
  components: { ObituaryImageInfo },
  selectors: imageInfo,
  store,
  template: "<ObituaryImageInfo />",
});

initImageInfo.init();

// Image info
const funeralProgram = document.getElementById(
  "obituary-funeral-program-image__vue"
);
const initFuneralProgramPages = new InitComponent({
  components: { FuneralProgramPages },
  selectors: funeralProgram,
  store,
  template: "<FuneralProgramPages />",
});

initFuneralProgramPages.init();

// "Visa bildspel" in the old hero version opens the viewer (the new hero opens it from the image)
const slideshowButtons = document.getElementsByClassName(
  "obituary-slideshow-button__vue"
);
for (const el of slideshowButtons) {
  el.addEventListener("click", (e) => {
    e.preventDefault();
    openViewer({ source: "old_button" });
  });
}

// Slideshow section: poster, inline playback and the thumbnail strip
const slideshowSection = document.getElementById(
  "obituary-slideshow-section__vue"
);
const initSlideshowSection = new InitComponent({
  components: { SlideshowSection },
  selectors: slideshowSection,
  store,
  template: "<SlideshowSection />",
});

initSlideshowSection.init();

// The memory book's own section, after Bildspel; hidden until the API sells the book here or will
const memoryBookSection = document.getElementById(
  "obituary-memory-book-section__vue"
);
const initMemoryBookSection = new InitComponent({
  components: { MemoryBookSection },
  data: {
    name: memoryBookSection?.dataset.deceasedNickname ?? "",
    postId: memoryBookSection?.dataset.obituaryId ?? "",
    sectionId: memoryBookSection?.dataset.sectionId ?? "",
    timeZone: memoryBookSection?.dataset.timeZone ?? "",
  },
  selectors: memoryBookSection,
  store,
  template:
    '<MemoryBookSection :name="name" :post-id="postId" :section-id="sectionId" :time-zone="timeZone" />',
});

initMemoryBookSection.init();

// The viewer, one per page: opened from the hero, the portrait, the section and Aktuellt
const slideshowViewer = document.getElementById(
  "obituary-slideshow-viewer__vue"
);
const initSlideshowViewer = new InitComponent({
  components: { SlideshowViewer },
  selectors: slideshowViewer,
  store,
  template: "<SlideshowViewer />",
});

initSlideshowViewer.init();

// Hero buttons
const heroButtons = document.getElementsByClassName(
  "obituary-comment-btn__vue"
);
for (const el of heroButtons) {
  el.addEventListener("click", (e) => {
    e.preventDefault();
    const clickAttr = el.getAttribute("@click.prevent") || "";
    const match = clickAttr.match(TOGGLE_MODAL_CONTEXT);
    const context = match ? match[1] : "";
    store.dispatch("createComment/toggleModal", context);
  });
}

// Navigation
const navigation = document.getElementById("obituary-navigation__vue");
const initNavigation = new InitComponent({
  components: { Navigation },
  selectors: navigation,
  store,
  template: "<Navigation />",
});

initNavigation.init();

// Mobile navigation
const mobileNavigation = document.getElementById(
  "obituary-mobile-navigation__vue"
);
const initMobileNavigation = new InitComponent({
  components: { MobileNavigation },
  selectors: mobileNavigation,
  store,
  template: "<MobileNavigation />",
});

initMobileNavigation.init();

// Create comment modal
const createCommentModal = document.getElementById(
  "obituary_create_comment_modal__vue"
);
const initCreateCommentModal = new InitComponent({
  components: { CreateCommentModal },
  selectors: createCommentModal,
  store,
  template: "<CreateCommentModal />",
});

initCreateCommentModal.init();

// Global single comment modal (share/edit/delete for the newly created comment,
// as well as any comment opened from masonry view). Mounted once at the top
// level so it works regardless of which comments view is active.
const globalSingleCommentModal = document.getElementById(
  "obituary_single_comment_modal__vue"
);
const initGlobalSingleCommentModal = new InitComponent({
  components: { GlobalSingleCommentModal },
  selectors: globalSingleCommentModal,
  store,
  template: "<GlobalSingleCommentModal />",
});

initGlobalSingleCommentModal.init();

// Single comment landing page modal
const singleCommentLandingPageModal = document.getElementById(
  "obituary-comment-landing-page-modal__vue"
);
const initSingleCommentLandingPageModal = new InitComponent({
  components: { SingleCommentLandingPageModal },
  selectors: singleCommentLandingPageModal,
  store,
  template: "<SingleCommentLandingPageModal />",
});

initSingleCommentLandingPageModal.init();

// Comments list
const commentsList = document.getElementById("obituary-comments-list__vue");
const initCommentsList = new InitComponent({
  beforeCreate() {
    this.$store.commit("comments/initialiseCreatedCommentsStore");
    this.$store.commit("comments/initialiseLikedCommentsStore");
  },
  components: { CommentsList },
  selectors: commentsList,
  store,
  template: "<CommentsList />",
});

initCommentsList.init();

store.subscribe((mutation, state) => {
  const {
    localStorageCreatedCommentsKey,
    localStorageLikedCommentsKey,
    createdComments,
    likedComments,
  } = state.comments;

  if (mutation.type.includes("setCreatedComments")) {
    safeSetItem(
      localStorageCreatedCommentsKey,
      JSON.stringify(createdComments)
    );
  }

  if (mutation.type.includes("setLikedComments")) {
    safeSetItem(localStorageLikedCommentsKey, JSON.stringify(likedComments));
  }
});
